import { apiClient } from './client';
import { unwrapList } from './unwrap';
import type { Award, AwardType, AwardTypePayload, CreateAwardRequest, PagedResult } from './types';

export const awardsApi = {
  listForCompetition: (competitionId: string) =>
    apiClient
      .get('/awards', { params: { competitionId } })
      .then((r) => unwrapList<Award>(r.data)) as Promise<PagedResult<Award>>,

  create: (payload: CreateAwardRequest) =>
    apiClient.post<Award>('/awards', payload).then((r) => r.data),

  remove: (id: string) => apiClient.delete(`/awards/${id}`).then((r) => r.data),

  listTypes: (competitionId: string) =>
    apiClient
      .get('/awards/types', { params: { competitionId } })
      .then((r) => unwrapList<AwardType>(r.data)) as Promise<PagedResult<AwardType>>,

  createType: (competitionId: string, payload: AwardTypePayload) =>
    apiClient.post<AwardType>('/awards/types', { competitionId, ...payload }).then((r) => r.data),

  updateType: (id: string, payload: AwardTypePayload) =>
    apiClient.put<AwardType>(`/awards/types/${id}`, payload).then((r) => r.data),

  removeType: (id: string) => apiClient.delete(`/awards/types/${id}`).then((r) => r.data),
};
